var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowCapsicum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2963",
    viewBox: "0 0 69.248 81.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(27.341 -212.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6619",
    transform: "matrix(-.91288 -.0069436 -.034059 .86024 427.64 -120.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6621",
    style: {
      strokeLinejoin: "round",
      fillRule: "evenodd",
      stroke: "#ddba05",
      strokeWidth: 3.8362,
      fill: "#fcc200"
    },
    d: "m426.1 393.97c-0.35 2.07-0.22 6.98-0.29 8.22 1.99 2.13 6.99-0.35 8.81 1.18s2.47 5.43 1.47 7.05c-0.41-0.44-2.13 1.61-4.7 2.35-2.85 0.81-7.91-1.68-11.16-0.88-3.25 0.79-7.58 3.39-9.4 5.87-1.81 2.48-2.14 3.67-2.35 9.1-0.2 5.43 3.17 19.39 4.7 26.43 1.53 7.05 2.43 16.82 5.29 20.56 2.86 3.73 5.64 3.94 8.81 4.99s9.27 0.8 12.04 1.47c2.77 0.66 4.48 2.95 6.46 2.35s3.67-3.11 4.4-4.41c1.29-0.97 3.62 1.99 5.58 2.35 1.97 0.37 3.16-0.26 7.05-2.35 3.9-2.08 9.82-11.13 12.34-16.15 2.51-5.02 4.09-10.24 4.69-16.44 0.61-6.21-0.01-19.04-2.05-24.38-2.05-5.33-5.25-9.38-8.22-10.86-2.98-1.48-6.41-0.5-8.52 0-2.11 0.49-3.86-0.56-5.29-0.88-1.16-0.27-5.38-1.33-8.81-1.47-2.03-1.98-1.81-5.45-3.52-7.93s-3.6-5.93-6.46-7.05-10.5-1.26-10.87 0.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6623",
    style: {
      fill: "#faba00"
    },
    d: "m433.23 414.1c-6.43 4.84-10.07 16.15-10.07 32.29 0 17.91 11.17 30.09 19.68 32.44-14.33-18.74-15.63-26.57-14.97-36.69s2.32-20.29 5.36-28.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6625",
    style: {
      fill: "#faba00"
    },
    d: "m448.88 411.21c7.18 3.62 12.79 14.09 15.68 29.97 3.2 17.63-5.63 31.6-13.58 35.44 6.06-21.88 6.82-29.23 5.24-39.07-1.57-9.79-2.97-19.26-7.34-26.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6627",
    style: {
      opacity: 0.62595,
      fill: "#fce94f"
    },
    d: "m413.75 439.17c-5.63-10.87-0.73-28.61 15.33-22.74-7.56 1.72-11.17 8.24-15.33 22.74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6629",
    style: {
      opacity: 0.62595,
      fillRule: "evenodd",
      fill: "#fce94f"
    },
    d: "m434.81 417.98c-1.69-3.21 9.89-6.61 13.26-3.83 3.37 2.79 0.65 15.04-1.42 15.27-1.54 0.18-10.27-8.45-11.84-11.44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6631",
    style: {
      fillRule: "evenodd",
      fill: "#4e9a06"
    },
    d: "m427.57 393.38c-1.37 1.43-2.2 6.67-0.59 8.23 1.62 1.56 5.85-1.47 7.93 0 2.09 1.47 1.45 10.04 3.53 8.51 2.2-1.62 4.33-1.1 6.75-0.88s-3.76-11.69-6.17-13.8c-2.4-2.11-4.12-1.76-5.87-2.06-1.74-0.29-4.2-1.42-5.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6633",
    style: {
      stroke: "#2d8f20",
      strokeWidth: 2.9335,
      fill: "none"
    },
    d: "m426.98 399.55s4.69 1.31 7.93-1.47c2.93-2.5 5.29 10.28 5.29 10.28"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCapsicum);
export default __webpack_public_path__ + "static/media/yellow-capsicum.94047222.svg";
export { ForwardRef as ReactComponent };